import { createFileRoute } from "@tanstack/react-router";
import ServiceLandingPage from "@/components/ServiceLandingPage";
import { SERVICE_META } from "@/data/servicePageMeta";

const PAGE = SERVICE_META["mercedes-sprinter-seat-capacity"]!;
const PAGE_URL = "https://sprinter-van-rentals.com/mercedes-sprinter-seat-capacity";

export const Route = createFileRoute("/mercedes-sprinter-seat-capacity")({
  head: () => ({
    meta: [
      { title: PAGE.title },
      { name: "description", content: PAGE.metaDescription },
      { property: "og:title", content: PAGE.title },
      { property: "og:description", content: PAGE.metaDescription },
      { property: "og:type", content: "article" },
      { property: "og:url", content: PAGE_URL },
      { property: "og:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://sprinter-van-rentals.com/sprinter913-91.png" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
  }),
  component: () => <ServiceLandingPage slug="mercedes-sprinter-seat-capacity" />,
});
